import { createContext, useContext } from 'react'
import { GoogleLocationClient } from './GoogleLocationAPI.model'
import { googleLocationClient } from './googleLocationClient'

/**
 * Which client the panel talks to. The app never provides one and gets the
 * backend or the stand-in (`config.ts`). A story always provides one, the
 * stand-in or one that fails on purpose to show the 429 and 503 states, since
 * the default now reaches the backend.
 */
export const GoogleLocationClientContext =
  createContext<GoogleLocationClient>(googleLocationClient)

export const useGoogleLocationClient = () =>
  useContext(GoogleLocationClientContext)
